import Cookies from "js-cookie";
import { checkResponse } from "src/components/js/statics1";

async function saveDarkModeToDB(token, personId, darkMode) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      personId: personId,
      darkMode: darkMode,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/person/setDarkMode",
    requestOptions
  );
  return await checkResponse(response, "darkModeClass.js:saveDarkModeToDB");
}

export function readDarkModeSetting() {
  try {
    let _dm = null;
    // localStorage
    _dm = localStorage.getItem("darkMode");
    if (JSON.parse(_dm) === true) return true;
    if (JSON.parse(_dm) === false) return false;
    // Cookies
    _dm = Cookies.get("darkMode");
    if (JSON.parse(_dm) === true) return true;
    if (JSON.parse(_dm) === false) return false;
    // default
    return null;
  } catch {
    // clear localstorage and cookies on error
    localStorage.removeItem("darkMode");
    Cookies.remove("darkMode");
    return null;
  }
}
function saveDarkModeToLocalstorage(darkMode) {
  localStorage.setItem("darkMode", darkMode);
  Cookies.set("darkMode", darkMode, { expires: 365 });
}

export async function saveDarkModeSetting(darkMode, personId, token) {
  if (darkMode === null) return false;
  saveDarkModeToLocalstorage(darkMode);

  if (!personId || !token || personId === 0) return false;
  await saveDarkModeToDB(token, personId, darkMode);
  return true;
}
